// ============================================================
// FYUNOR — Google Analytics 4
// Thin wrapper around gtag for SPA page-view tracking.
// The gtag script + config live in index.html; this module
// fires manual page_view events on route changes.
// ============================================================

/**
 * Send a GA4 page_view event for a virtual page.
 * @param {string} path — the path + query string (e.g. "/us/calculators/salary")
 */
export function pageview(path) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", { page_path: path });
}